import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import * as yup from 'yup';

/** Common email address validation schema */
export const emailSchema = yup
  .string()
  .email(DtoMessageEnum.INCORRECT_EMAIL);
